import React from 'react';
import IconButton from '@mui/material/IconButton';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import PropTypes from 'prop-types';

const AvatarSelect = (props) => {
	const { disabled, id, onInputChange } = props;

	const handleAvatarUpload = (event) => {
		event.preventDefault();

		const objectUrl = URL.createObjectURL(event.target.files[0]);
		onInputChange(objectUrl, id);
	};

	return (
		<>
			<input
				accept="image/*"
				style={{ display: 'none' }}
				id={id}
				type="file"
				onChange={handleAvatarUpload}
				disabled={disabled}
			/>
			<label
				htmlFor={id}
				style={{
					display: 'flex',
					flexDirection: 'column',
					width: 'fit-content'
				}}
			>
				<IconButton
					color="primary"
					aria-label="upload picture"
					component="span"
				>
					<AddCircleIcon />
				</IconButton>
			</label>
		</>
	);
};

AvatarSelect.propTypes = {
	disabled: PropTypes.bool,
	errors: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	onInputChange: PropTypes.func,
	onInputFocus: PropTypes.func,
	required: PropTypes.bool
};

export default AvatarSelect;
